import axios from 'axios'

export default async function fetchSupportMeta() {
  const { data } = await axios.get('/api/v1/support/meta/')

  return data
}
